import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { Dialog } from 'src/components/shared/dialog/Dialog';
import { RootState } from '../../../features';
import { DreamErrorType } from '../../../features/dream';
import { DreamHistory } from '../../../models/dream/DreamHistory';
import { FadeRoute } from '../../shared/routes/FadeRoute';
import { ConfirmDeletePage } from './ConfirmDeletePage';
import { DreamHistoryDetail } from './DreamHistoryDetail';
import { DreamHistoryDetailMenu } from './DreamHistoryDetailMenu';

export const DreamHistoryDetailDialog: React.FC = () => {
  const routeMatch = useRouteMatch();
  const location = useLocation();
  const params = useParams<{ address?: string }>();
  const { t } = useTranslation(['dream', 'translation']);
  const history = useHistory();
  const { history: dreamHistory, historyDetail } = useSelector((state: RootState) => state.dream);

  const handleMenuClick = () => {
    if (params?.address) {
      const { address } = params;
      history.replace(`/players/dream/history/detail/${address}/menu/1`);
    }
  };

  let historyItem: DreamHistory | undefined;
  // workaround: 履歴削除成功直後にDreamHistoryDetailが非表示になりダイアログの高さが変わってしまうのを防ぐ
  if (historyDetail.deleteState?.state === 'ok') {
    historyItem = historyDetail.deleteState.result;
  } else if (dreamHistory.state === 'ok') {
    historyItem = dreamHistory.result.histories.find(
      item => item.dreamLand.address === params?.address
    );
  }

  let errorType: DreamErrorType | undefined;
  if (historyDetail.userProfile?.state === 'error') {
    errorType = historyDetail.userProfile.error;
  }

  const hasMenu = routeMatch?.url === location.pathname;

  return (
    <Dialog
      hasHeader={true}
      hasMenu={hasMenu}
      onMenuClick={handleMenuClick}
      menuAriaLabel={t('aria_button_to_report_menu')}
    >
      <>
        <div
          className={css`
            position: relative;
            .menu-pages {
              position: absolute;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 100%;
            }
          `}
        >
          {historyItem && (
            <DreamHistoryDetail
              isMyIsLandDream={false}
              address={historyItem.dreamLand.address}
              uploadUser={historyItem.uploadUser}
              visitedAt={historyItem.visitedAt}
              updatedAt={historyItem.dreamLand.updatedAt}
              errorType={errorType}
            />
          )}
          <div className="menu-pages">
            <FadeRoute path="/players/dream/history/detail/:address/menu/1">
              <DreamHistoryDetailMenu uploadUser={historyItem?.uploadUser} />
            </FadeRoute>
            <FadeRoute path="/players/dream/history/detail/:address/menu/2">
              <ConfirmDeletePage />
            </FadeRoute>
          </div>
        </div>
      </>
    </Dialog>
  );
};
